import { Stack, styled, Typography } from '@mui/material'
import { ReactComponent as SvgError } from 'assets/toast/error.svg'
import { ReactComponent as SvgInfo } from 'assets/toast/info.svg'
import { ReactComponent as SvgSuccess } from 'assets/toast/success.svg'
import { FC, memo, useEffect } from 'react'
import { NotificationStatus } from '../../../api/v1/message'
import Iconfont from '../../../components/Iconfont'
import { NoData } from '../../../components/NoData'
import { Flex, FlexColumn } from '../../../styles'
import { DateFormatter } from '../../../utils/datetime'
import { useNotificationPagination } from './index'

const ListWrap = styled(FlexColumn)`
  overflow: auto;
  max-height: 240px;
  padding: 0 17px;
  ${(props) => props.theme.breakpoints.down('md')} {
    & {
      max-height: 60vh;
    }
  }
`

const NotificationContent = styled(FlexColumn)`
  flex: 1;
`
const NotificationTitle = styled(Flex)`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.color.text100};
  justify-content: space-between;
  .title {
    display: flex;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 200px;
  }
  span,
  .iconfont {
    display: flex;
    width: 20px;
    height: 20px;
    justify-content: center;
    align-items: center;
    color: ${(props) => props.theme.color.text60};
    border-radius: 4px;
    cursor: pointer;
    &:hover {
      background-color: ${(props) => props.theme.color.bg};
    }
  }
`
const NotificationText = styled(FlexColumn)`
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: ${(props) => props.theme.color.text90};
`
const NotificationTime = styled(Typography)`
  font-size: 12px;
  line-height: 14px;
  color: ${(props) => props.theme.color.text50};
  margin-top: 2px;
`
const NotificationItem = styled(Stack)`
  flex-direction: row;
  align-items: flex-start;
  padding: 8px 12px;
  border-radius: 4px;
  /* background-color: ${(props) => props.theme.color.bg}; */
  background-color: rgba(42, 49, 57, 1);
  margin-bottom: 12px;
  svg {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    margin-right: 12px;
    margin-top: 3px;
  }
`
const NoMore = styled(Typography)`
  text-align: center;
  font-size: 12px;
  color: ${(props) => props.theme.color.text30};
`
const ShowMore = styled(NoMore)`
  color: ${(props) => props.theme.color.text80};
  cursor: pointer;
`

export const NotificationList: FC<{
  isShowModal: boolean
}> = memo(({ isShowModal }) => {
  const { list, del, read, showMore, hasMore } = useNotificationPagination()

  useEffect(() => {
    if (isShowModal) {
      read()
    }
  }, [isShowModal])

  return (
    <ListWrap>
      {list.length ? (
        <>
          {list?.map((item, index) => {
            return (
              <NotificationItem key={`${item.id}${index}`}>
                {item?.messageStatus === NotificationStatus.Successful ? (
                  <SvgSuccess />
                ) : item?.messageStatus === NotificationStatus.Failed ? (
                  <SvgError />
                ) : (
                  <SvgInfo />
                )}
                <NotificationContent>
                  <NotificationTitle>
                    <div className="title">{item.title}</div>
                    {/* <span onClick={() => del(item.id)}>
                      <Iconfont name="icon-close2" size={18}></Iconfont>
                    </span> */}
                  </NotificationTitle>
                  <NotificationText>{item.content}</NotificationText>
                  {/* <NotificationTime>
                    {DateFormatter.toISODateTime(item.createTime)}
                  </NotificationTime> */}
                </NotificationContent>
              </NotificationItem>
            )
          })}
          {hasMore ? (
            <ShowMore onClick={() => showMore()}>Show more</ShowMore>
          ) : (
            <NoMore>No more</NoMore>
          )}
        </>
      ) : (
        <NoData height={'100px'} />
      )}
    </ListWrap>
  )
})
